import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import StatusPill from "ui-components/status-pill/statusPill";
import TimestampDisplay from "ui-components/timestamp-display/timestampDisplay";
import {
  employeeActivityPillVariant,
  humanizeEmployeeActivityEventType,
  summarizeEmployeeActivityChanges,
} from "app/data/dock-scan/dockLogMappers";
import { EmployeeActivityEvent } from "app/data/dock-scan/models";
import { DataTableColumnOption } from "ui-components/data-table/dataTableTypes";

const columnHelper = createColumnHelper<EmployeeActivityEvent>();

export const DOCK_EMPLOYEE_ACTIVITY_COLUMN_OPTIONS: DataTableColumnOption[] = [
  { id: "createdAt", label: "Time" },
  { id: "eventType", label: "Event" },
  { id: "actorEmail", label: "Actor" },
  { id: "changes", label: "Changes" },
];

export function getDockEmployeeActivityColumns() {
  return [
    columnHelper.accessor("createdAt", {
      id: "createdAt",
      header: "Time",
      cell: (props) => <TimestampDisplay value={props.getValue()} format="local" />,
      size: 140,
      minSize: 120,
    }),
    columnHelper.accessor("eventType", {
      id: "eventType",
      header: "Event",
      cell: (props) => (
        <StatusPill
          label={humanizeEmployeeActivityEventType(props.getValue())}
          variant={employeeActivityPillVariant(props.getValue())}
        />
      ),
      size: 130,
      minSize: 110,
    }),
    columnHelper.accessor("actorEmail", {
      id: "actorEmail",
      header: "Actor",
      cell: (props) => props.getValue() || "—",
      size: 180,
      minSize: 140,
    }),
    columnHelper.display({
      id: "changes",
      header: "Changes",
      cell: (props) => (
        <span className="dock-users__activity-changes">
          {summarizeEmployeeActivityChanges(props.row.original.metadata)}
        </span>
      ),
      size: 280,
      minSize: 180,
    }),
  ];
}
